<template>
        <div :class="['contact_copy_form',value?'is-visible':'']">
            <div class="cmfLibrarydetail clearfix" v-if="dto.id>0">
				<div class="toBar">
					<h2>详情</h2>
					<a href="javascript:void(0);" class="closePop" @click="CloseMaterial()">关闭</a>
				</div>
				<div class="DetailConWap">
					<div class="right_item_content">
					    <!-- <div class="companyInfo" v-if="dto.company">
					        <div class="infoBox clearfix">
					            <div class="logo">
					                <span>
					                   <img :src="utils.HandleImg(dto.company.main_pic,false,1)" alt="">
					                </span>
					            </div>
					            <div class="desc">
					                <div class="title">{{dto.company.company_name}}</div>
					                <div class="label">{{dto.company.company_type}}</div>
					                <div class="mark">
					                    <img v-if="dto.company.ruzhu_type_image" :src="utils.HandleImg(dto.company.ruzhu_type_image)" alt="">
					                    <img v-if="dto.company.renzheng_img" :src="utils.HandleImg(dto.company.renzheng_img)" alt="">
					                </div>
					                <div class="view">
					                    <a @click="PopCompany(dto.company.company_id)"><em>查看企业</em></a>
					                </div>
					            </div>
					        </div>
					    </div> -->
					    <div class="desc_item">
					        <div class="item">
					            <span>应用</span>
					            <div class="application clearfix">
					                <ul>
					                    <template v-for="(item,index) in dto.material_props.lingyu">
					                    <li :key="'props_'+index" v-if="item.selected">
					                        <img :src="utils.HandleImg(item.img_url,false,1)" >
					                        <p>{{item.title}}</p>
					                    </li>
					                    </template>
					                </ul>
					                
					            </div>
					        </div>
					        <div class="item dsi_guide">
					            <h2>设计指导</h2>
					            <div class="zd_list">
					                <ul>
					                    <li class="clearfix">
					                        <span class="name">材质</span>
					                        <div class="label">
					                            <template v-for="(item,index) in dto.material_props.caizhi">
					                                <span v-if="item.selected" :class="{curr:item.selected}" :key="'caizhi_'+index">{{item.title}}</span>
					                            </template>
					                        </div>
					                    </li>
					                    <li class="clearfix">
					                        <span class="name">成熟度</span>
					                        <div class="label"><span class="curr">{{dto.chengshudu}}</span></div>
					                    </li>
					                    <li class="clearfix" v-if="dto.material_props.changjing.length>0">
					                        <span class="name">场景</span>
					                        <div class="label">
					                            <template v-for="(item,index) in dto.material_props.changjing">
					                                <span v-if="item.selected" :key="'changjing_'+index" :class="{curr:item.selected}">{{item.title}}</span>
					                            </template>
					                        </div>
					                    </li>
					                    <template v-for="(item,index) in dto.material_props.gongneng">
					                        <li class="clearfix" :key="'gongneng1_'+index">
					                            <span class="name">{{item.title}}</span>
					                            <div class="label">
					                                <template v-for="(item2,index2) in item.children">
					                                    <span :key="'gongneng2_'+index2" :class="{curr:item2.selected}">{{item2.title}}</span>
					                                </template>
					                            </div>
					                        </li>
					                    </template>
					                    <template v-if="dto.material_props.gongyi.length>0">
					                        <li class="clearfix">
					                            <span class="name">工艺</span>
					                            <div class="label">
					                                <template v-for="(item,index1) in dto.material_props.gongyi">
					                                    <template v-for="(item2,index2) in item.children">
					                                        <span :key="'gongyi_'+index1+'_'+index2" v-if="item2.selected" :class="{curr:item2.selected}">{{item2.title}}</span>
					                                    </template>
					                                </template>
					                            </div>
					                        </li>
					                    </template>
					                </ul>
					            </div>
					        </div>
					    </div>
					</div>
					
					<div class="left_item_content">
					    <div class="picbundle">
					        <div class="topBar clearfix">
					            <div class="btnItem">
					                <a class="b3" href="javascript:void(0);" @click="show_consult=true">咨询</a>
					            </div>
					            <div class="topName">
					                {{dto.title}}
					            </div>
					        </div>
					        <div class="slideswiper">
					            <div class="swiper-container">
					                <div class="swiper-wrapper">
					                    <div class="swiper-slide swiper-zoom-container" v-for="(image, index) in dto.albums" :key="index">
					                        <img :src="utils.HandleImg(image.original_path,false,1)" />
					                    </div>
					                </div>
					                <!-- Add Pagination -->
					                <div class="swiper-pagination"></div>
					                <!-- Navigation -->
					                <div class="swiper-button-next"></div>
					                <div class="swiper-button-prev"></div>
					            </div>
					        </div>
					    </div>
					    <div class="detail_desc">
					        <div class="tibar">
					            <h2>详细介绍</h2>
					        </div>
					        <div class="descCon" v-html="utils.HandleContentImg(dto.content)">
					        </div>
					    </div>
					</div>
					
				</div>
               
               
            </div>
 
		    <ConsultMaterial :id="id" v-model="show_consult" v-if="show_consult"></ConsultMaterial>

        </div>
</template>

<script>
import {Drawer,Dialog} from "element-ui";
import ConsultMaterial from '../../components/Demand/ConsultMaterial'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import {mapActions} from 'vuex'
import $ from 'jquery'

export default {
    data(){
        return{
            dto:{},
            title:'材料详情',
			title1:'',
			show_consult: false,
        }
    },
	props:{
		value:{},
		id:{}
	},
    components:{
		ConsultMaterial,
	   [Drawer.name]: Drawer,
	   [Dialog.name]: Drawer,
    },
    created(){
        if (this.paramid>0) this.id=this.paramid;
    },
    mounted:function(){
		$('.closePop').on('click', function (event) {
			event.preventDefault();
			$('.contact_copy_form').removeClass('is-visible');
		});
        this.GetDetail();
    },
    methods:{
        ...mapActions('Common',['setMinwinTitle']),
        GetDetail(){
            var url="http://api.xincailiao.com/Open/GetMaterialDetail";
            this.$http.post(url,{id:this.id}).then(function(res){
                if (res.data.status==1){
                    this.dto=res.data.ds;
                    this.InitAlbums();
                    this.title=res.data.ds.title;
                }
            }.bind(this)).catch(function(){
            });
        },
        InitAlbums(){
            this.$nextTick(function(){
                new Swiper('.swiper-container', {
                    zoom:true,
                    slidesPerView: 1,
                    centeredSlides: true,
                    loop: true,
                    autoplay: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            })
        },
		CloseMaterial(){
			this.$emit('input',false);
		},
		
    },
	watch:{
		id(){
			this.GetDetail();
		}
	}
}
</script>